import { useRequiredParams } from '@pba/react-router';
import { OrganizationLayout, OrganizationsVideos } from 'features/organizations';
import { useGetPathToEntityDetail } from '../../hooks';

const PageOrganizationsVideos = () => {
  const { organizationId } = useRequiredParams<{ organizationId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <OrganizationLayout organizationId={organizationId}>
      {(organization) => (
        <OrganizationsVideos
          getPathToVideoDetail={(id) => getPathToEntityDetail(id, { entityType: 'video' })}
          organization={organization}
        />
      )}
    </OrganizationLayout>
  );
};

export default PageOrganizationsVideos;
